export default {
    WEB_SDK: {
        AUTH_ENDPOINT: process.env.REACT_APP_AUTH_ENDPOINT,
        AUTH_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
        ID_ENDPOINT: process.env.REACT_APP_ID_ENDPOINT,
        FRM_ENDPOINT: process.env.REACT_APP_FRM_ENDPOINT,
        MEDICSCAN_ENDPOINT: process.env.REACT_APP_MEDICSCAN_ENDPOINT,
        LIVENESS_ENDPOINT: process.env.REACT_APP_LIVENESS_ENDPOINT,
        USER_NAME: process.env.REACT_APP_USER_NAME,
        PASSWORD: process.env.REACT_APP_PASSWORD,
        SUBSCRIPTION_ID: process.env.REACT_APP_SUBSCRIPTION_ID,
    },
};
